import React from "react";
import { BankAccount } from "../../types/api/odt";
import i18n from "../../i18n/config";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { UpdateDestinationInfo } from "../../actions/onDemandTransfer";
import { ROUTES } from "../../constants/clientRoutes";
import { BANK_ACCOUNT_STATUS, ACTION_DISPLAY_TYPES, BANK_ACCOUNT_CARD_TYPES, BANK_ACCOUNT_FLOW_TYPES } from "../../constants/enums";
import { BankAccountCardType } from "../../types/components";
import { BankAccountDeleted, SetBankAccountDisbursementHistory, ShowDeleteModal, UpdateBankAcccountParams } from "../../actions/bankAccounts";

import Action from "./Action";
import BankAccountsApi from "../../api/bankAccounts";
import useErrorModal from "../../hooks/useErrorModal";
import { GetDisbursementHistoryResponse } from "../../types/api/bankAccounts";

type DestinationData = {
  destinationCountryName: string;
  destinationCountryId: string;
}

const BankAccountCardActions = ({ bank, type, destinationData }: { bank: BankAccount, type?: BankAccountCardType, destinationData?: DestinationData }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const openErrorModal = useErrorModal();
  const { destinationCountryName, destinationCountryId } = destinationData || {};

  const handleEditBank = () => {
    dispatch(UpdateBankAcccountParams(BANK_ACCOUNT_FLOW_TYPES.EDIT, bank.allocationId));
    history.push(`${ROUTES.BANKS_ACCOUNTS.BENEFICIARY_DETAILS}?destinationCountryId=${destinationCountryId}&destinationCurrencyCode=${bank.destinationCurrencyCode}&allocationId=${bank.allocationId}`);
  }

  const handleSelectBank = () => {
    const payload = {
      allocationId: String(bank.allocationId),
      destinationCurrency: bank.destinationCurrencyCode,
      destinationCountryIso: bank.destinationCountryIso,
      destinationCountryName: destinationCountryName ?? "",
      destinationCountryId: destinationCountryId ?? "",
      isPOPRequired: bank.isPOPRequired,
      isPinRequired: bank.isPinRequired,
      isDoddFrank: bank.isDoddFrank,
      bankAccountFeeBanner: bank.feeBanner
    };
    dispatch(UpdateDestinationInfo(payload));

    history.push(ROUTES.ODT.AMT_PURPOSE);
  };

  const handleViewHistory = async () => {
    try {
      const response = await BankAccountsApi.GetDisbursementHistory(bank.allocationId) as GetDisbursementHistoryResponse;
      dispatch(SetBankAccountDisbursementHistory({
        showDisbursementHistory: true,
        bankAccountName: bank.accountName,
        bankAccountNumber: bank.accountNumber,
        disbursementHistory: response.result
      }));
    } catch (err) {
      openErrorModal(err);
    }
  }

  const handleDeleteBank = () => {
    dispatch(BankAccountDeleted(false));
    dispatch(ShowDeleteModal(bank.allocationId, true));
  }

  return (
    <div className="bwp-panel-row__actions" data-cy={`bank-account-card-actions`}>
      {bank.bankAccountStatus === BANK_ACCOUNT_STATUS.AVAILABLE && type === BANK_ACCOUNT_CARD_TYPES.BANK_ACCOUNT &&
        <Action
          displayType={ACTION_DISPLAY_TYPES.TEXT}
          size="md"
          width="auto"
          title={i18n.t("COMMON.DELETE")}
          onClick={() => handleDeleteBank()}
        />
      }

      {bank.bankAccountStatus === BANK_ACCOUNT_STATUS.AVAILABLE && type === BANK_ACCOUNT_CARD_TYPES.BANK_ACCOUNT &&
        <Action
          displayType={ACTION_DISPLAY_TYPES.SECONDARY}
          title={i18n.t("COMMON.VIEW_HISTORY")}
          size="md"
          width="short"
          onClick={() => handleViewHistory()}
        />
      }

      {bank.canEdit && type === BANK_ACCOUNT_CARD_TYPES.BANK_ACCOUNT &&
        <Action
          displayType={ACTION_DISPLAY_TYPES.SECONDARY}
          title={i18n.t("COMMON.EDIT")}
          size="md"
          width="auto"
          onClick={() => handleEditBank()}
        />
      }

      {bank.bankAccountStatus === BANK_ACCOUNT_STATUS.AVAILABLE && type === BANK_ACCOUNT_CARD_TYPES.ODT &&
        <Action
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
          title={i18n.t("COMMON.SELECT")}
          size="md"
          width="short"
          onClick={() => handleSelectBank()}
        />
      }

      {bank.bankAccountStatus === BANK_ACCOUNT_STATUS.INCOMPLETE &&
        <Action
          displayType={ACTION_DISPLAY_TYPES.SECONDARY}
          title={i18n.t("COMMON.FIX")}
          size="md"
          width="auto"
          onClick={() => handleEditBank()}
        />
      }

      {bank.bankAccountStatus === BANK_ACCOUNT_STATUS.UNDER_REVIEW &&
        <p>{i18n.t("PAGES.ODT.BANK_SELECTION.ACCOUNT_UNDER_REVIEW_LABEL")}</p>
      }
    </div>
  );
}

export default BankAccountCardActions;